/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */
/**
 * Libraries
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Consignments
 */
import { ConsignmentsRoutingModule } from './consignments-routing.module';
import { ConsignmentsComponent } from './consignments.component';

/**
 * External Modules
 */
import { HeaderModule } from '../../shared/header/header.module';
import { FooterModule } from '../../shared/footer/footer.module';

/**
 * Providers
 */
import { BaseSettingsService } from '../../providers/base-settings.service';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    ConsignmentsRoutingModule,
  ],
  declarations: [
    ConsignmentsComponent,
  ],
  providers: [
    BaseSettingsService
  ]
})
export class ConsignmentsModule { }
